@if (isPolicyViewEnabled && showPolicyView) {
  <app-policy-view-wrapper
    [policyView]="policyView"
    (eventTriggered)="onAction($event)"
    [theme]="theme"
  ></app-policy-view-wrapper>
} @else {
  <div class="main">
    @if (policy) {
      <div>
        <div class="pad-bottom-30 jump-links-wrapper">
          <ds-jump-links [jumpLinks]="jumpLinks"></ds-jump-links>
        </div>
        <div class="row">
          <property-risk-card
            [newTemplate]="true"
            [linkAddressChange]="requestChangeNewTemplate"
            [showDocuments]="(policyDocuments | async)?.length > 0"
          ></property-risk-card>
        </div>
        <div class="row pad-top-20 pad-bottom-20">
          <div class="image-container">
            <img src="/assets/images/property.svg" />
          </div>
          <div class="view-coverge-details-wrapper">
            <button (click)="onCoverageDetailsClicked()">
              <div>View Coverage Details</div>
              <img src="/assets/images/doodle-arrow.svg" alt="View Coverage Details" />
            </button>
          </div>
          <div class="simple-cards">
            <div class="left">
              <div class="margin-bottom-20">
                <ds-simple-card
                  headerIcon="dollar-sign_doodle.svg"
                  heading="Premium"
                  [buttons]="premiumActionButtons$ | async"
                  id="premiumCard"
                >
                  <policy-discounts [policy]="policy"></policy-discounts>
                </ds-simple-card>
              </div>
              <div>
                <ds-simple-card
                  headerIcon="key-and-house_home_doodle.svg"
                  heading="People Covered"
                  [buttons]="peopleCoveredActionButtons"
                  id="peopleCoveredCard"
                >
                  @if (nameInsured) {
                    <ds-key-value-card
                      classes="pad-bottom-20"
                      [key]="nameInsuredHeading"
                      [value]="nameInsured"
                      [tooltipTemplateRef]="nameInsuredRef"
                    ></ds-key-value-card>
                  }
                </ds-simple-card>
              </div>
            </div>
            <div class="right">
              <ds-simple-card
                headerIcon="coverage.svg"
                heading="Coverage for My Home"
                [buttons]="coverageActionButtons"
                id="coveragesCard"
              >
                <app-coverages [newAFITemplate]="true" [policy]="policy"></app-coverages>
              </ds-simple-card>
            </div>
          </div>
        </div>
        <div class="new-documents" id="documentsCard">
          <policy-documents [documents]="policyDocuments | async"></policy-documents>
        </div>
        <ng-template #nameInsuredRef>
          <div class="tooltip-content-wrapper">
            <ds-content-wrapper context="propertynameinsured"></ds-content-wrapper>
          </div>
        </ng-template>
        <ng-template #additionalInsuredRef>
          <div class="tooltip-content-wrapper">
            <ds-content-wrapper context="propertyadditionalinsured"></ds-content-wrapper>
          </div>
        </ng-template>
        <div class="policy-footer">
          <span
            *dsPartnerAFI
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'agent' }"
          ></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'representative' }"
          ></span>
          <span *dsPartnerAFI dsContent [contentPath]="'policyDetail.detailFooterTextAFI'"></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterTextPartner'"
          ></span>
        </div>
      </div>
    }
  </div>
}
